module.exports = __webpack_public_path__ + "img/icon_map.854b253d.png";